"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.orderSent = void 0;
const constants_1 = require("../constants");
const getOrderProps = ({ cart, session, storefront }) => ({
    [constants_1.EventProperty.CART_PRODUCT_CATEGORIES]: cart.categories,
    [constants_1.EventProperty.CART_PRODUCT_IDS]: cart.ids,
    [constants_1.EventProperty.CART_PRODUCT_NAMES]: cart.names,
    [constants_1.EventProperty.CART_PRODUCT_SKUS]: cart.skus,
    [constants_1.EventProperty.CART_SIZE]: cart.size,
    [constants_1.EventProperty.CART_VALUE]: cart.value,
    [constants_1.EventProperty.CUSTOM_NOTE_TEXT]: cart.note,
    [constants_1.EventProperty.CURRENCY]: storefront.currency,
    [constants_1.EventProperty.CUSTOMER_NAME]: session.customer,
    [constants_1.EventProperty.USER_ID]: session.userID,
    [constants_1.EventProperty.PRODUCT_SUMMARIES]: cart.product_summaries,
    [constants_1.EventProperty.SESSION_ID]: session.sessionID
});
exports.orderSent = ({ cart, session, storefront }) => {
    const props = getOrderProps({ cart, session, storefront });
    window.analytics.track(constants_1.EventName.ORDER_SENT, props);
};
